module.exports = __webpack_public_path__ + "static/media/Solar_Panel.244d6df1.png";